import { REPORT_TYPES_SLOT } from './relatorios'

export default [
  {
    key: 'dashboard',
    icon: 'mdi-view-dashboard',
    title: 'Dashboard',
    to: '/consultor/dashboard',
  },
  {
    key: 'fazendas',
    icon: 'mdi-home-flood',
    title: 'Fazendas',
    to: '/consultor/fazendas',
  },
  {
    key: 'financeiros',
    icon: 'mdi-cash',
    title: 'Lançamento Financeiro',
    to: '/consultor/financeiros',
  },
  {
    key: 'agenda',
    icon: 'mdi-calendar-month',
    title: 'Agenda',
    to: '/consultor/schedules',
  },
  {
    key: 'relatorios-grupo',
    icon: 'mdi-clipboard-list',
    title: 'Relatórios',
    group: '/consultor/relatorios',
    children: [
      {
        key: 'visitas-grupo',
        subicon: 'mdi-clipboard-list',
        title: 'Visitas',
        group: '/consultor/relatorios',
        children: [REPORT_TYPES_SLOT],
      },
      {
        key: 'gerenciais-grupo',
        title: 'Gerenciais',
        group: '/consultor/relatorios',
        children: [
          {
            key: 'localizacao',
            icon: 'mdi-home-search',
            title: 'Localização das Propriedades',
            to: 'localizacao',
          },
        ],
      },
    ],
  },
]
